import { render, staticRenderFns } from "./doneRead.vue?vue&type=template&id=3c616ffc&scoped=true&"
import script from "./doneRead.vue?vue&type=script&lang=js&"
export * from "./doneRead.vue?vue&type=script&lang=js&"
import style0 from "./doneRead.vue?vue&type=style&index=0&id=3c616ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c616ffc",
  null
  
)

export default component.exports